import React from "react";
import facebookGreyLogo from "../../images/f_Logo-Grey-Logo.wine.svg"
import time_logo from "../../images/time.svg"
import fbLike from "../../images/like.svg"
import fbLove from "../../images/love.svg"
import fbWow from "../../images/wow.svg"


export default function InfiniteCard({ hit }) {
	let mainText = hit["primary_text"];
	let mainTextArray = mainText.split("\n");

	function AddButton() {
		return (
			<>
				<button
					className="btn-show-more"
					onClick={showMore}
					id={`btn-show-more-${hit["objectID"]}`}
				>
					Read More
				</button>
				<button
					className="btn-show-more"
					style={{ display: "none" }}
					onClick={showLess}
					id={`btn-show-less-${hit["objectID"]}`}
				>
					Read Less
				</button>
			</>
		);
	}

	// Cut Description Text and replace with Ellipsis Function
	function truncateText(text, length) {
		if (text.length <= length) {
		  return text;
		}
	  
		return text.substr(0, length) + '\u2026'
	  }
	  


	function ConditionalButton(props) {
		let numberOfLines = mainTextArray.length;
		let charCount = mainText.length;
		if (numberOfLines > 1 && charCount > 30) {
			return <AddButton />;
		} else {
			return null;
		}
	}

	function showMore() {
		// document.getElementById(`text-body-${hit["objectID"]}`).innerHTML = hit["Main text"];
		document.getElementById(`text-body-${hit["objectID"]}`).style =
			"--max-lines: 100";
		document.getElementById(`btn-show-more-${hit["objectID"]}`).style =
			"display:none";
		document.getElementById(`btn-show-less-${hit["objectID"]}`).style =
			"display:block";
	}

	function showLess() {
		// document.getElementById(`text-body-${hit["objectID"]}`).innerHTML = "partial text...";
		document.getElementById(`text-body-${hit["objectID"]}`).style =
			"height:150px";
		document.getElementById(`btn-show-more-${hit["objectID"]}`).style =
			"display:block";
		document.getElementById(`btn-show-less-${hit["objectID"]}`).style =
			"display:none";
	}

	return (
		<div className="card-container ">
			<div className="card-header-container ">
				<div className="card-header-container-box1">
					<div className="card-profile-pic-container">
						<img className="card-pro-img" alt="Brand Logo Here" src={hit["profile_pictures"]} />
					</div>
					<div className="card-header-wrapper ">
						<span className="card-title ">{hit["page_name"]}</span>

						<span className="date-posted ">
							<img className="time_logo " alt="Date of the post" src={time_logo} />
							{hit["date_posted"]}
						</span>
					</div>
				</div>	
				<div className="card-link-wrapper ">
					{/* <span className="card-topAd-rating">
					
						{hit["top_percentage_ad"]}​ 
					
					</span> */}
					<span>
						<a href={hit["fb_video_ad_link"]}>
							<img
								className="mini-fb-logo "
								alt="Link to video, on Facebook"
								src={facebookGreyLogo}
							/>
						</a>
					</span>
				</div>
			</div>	

			<div className="card-text-wrapper ">
				<div
					className="text-overflow truncate-overflow "
					id={`text-body-${hit["objectID"]}`}
				>
					<p className="description-paragraph">
						{mainTextArray.map((text) => {
							return <p>{text}</p>;
						})}
					</p>
				</div>

				<ConditionalButton />
			</div>

			<div className="card-video-wrapper ">
				<smartvideo
					src={hit["video_links_dropbox"]}
					width="800"
					height="800"
					className="swarm-fluid"
					controls
				></smartvideo>
			</div>

			<div className="card-shop-container ">
				<div className="card-shop-headline-wrapper ">
					{/* <!--  <span className="outbound-URL ">{{Outbound URL}}</span>  -->  */}
					<span className="main-headline ">{hit["headline"]}</span>
					<span className="main-description">{truncateText(hit["description"] , 35)}</span>
				</div>

				<div className="card-shop-button-wrapper ">
					<span className="shop-now ">
						<button className="show-button ">Shop Now</button>
					</span>
				</div>
			</div>

			<div className="card-social-container ">
				<div className="card-social-stats-wrapper">
					<span>{hit["commentss"]} Comments</span>
					<span> </span>
					<span>{hit["shares_"]} Shares</span>
					<span> </span>
					{/* <span>{hit["Video Views"]} Views</span> */}
				</div>

				<div className="card-react-wrapper ">
					<span className="post-react ">
						<img
							src={fbLike}
							alt="Thumbs up, Heart, and Laugh emoji. Number of reactions to post"
							className="post-react-img-a"
						/>
						<img
							src={fbLove}
							alt="Thumbs up, Heart, and Laugh emoji. Number of reactions to post"
							className="post-react-img-b"
						/>
						<img
							src={fbWow}
							alt="Thumbs up, Heart, and Laugh emoji. Number of reactions to post"
							className="post-react-img-c"
						/>
						
						<span className="post-react-likes"> {hit["post_reactions"]} Likes </span>
					</span>
				</div>
			</div>
		</div>
	);
}
